module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/babel-runtime/core-js/is-iterable.js
// module id = 273
// module chunks = 0